import { render, staticRenderFns } from "./BoxTrackListEmptyCard.vue?vue&type=template&id=50e9fa1e&scoped=true&"
import script from "./BoxTrackListEmptyCard.vue?vue&type=script&lang=js&"
export * from "./BoxTrackListEmptyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e9fa1e",
  null
  
)

export default component.exports